export const presenceDashboardContext = Object.freeze({
  CHECK_IN_DASHBOARD: 'check_in_dashboard',
  EMPLOYEE_DASHBOARD: 'employee_dashboard',
  GUARDIAN_DASHBOARD: 'guardian_dashboard',
});
